import { render, staticRenderFns } from "./txt-tertiary.vue?vue&type=template&id=05f59d5a&scoped=true&"
import script from "./txt-tertiary.vue?vue&type=script&lang=js&"
export * from "./txt-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f59d5a",
  null
  
)

export default component.exports